"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultSettings_1 = require("./defaultSettings");
var HttpApiSettingsBase = /** @class */ (function () {
    function HttpApiSettingsBase(options) {
        var config = options.config, assertStatusCode = options.assertStatusCode, circuitBreakerHash = options.circuitBreakerHash, defaultSettings = options.defaultSettings, target = options.target;
        this.config = config;
        this.target = target;
        this.projectName = config.getStrict('projectName');
        this.assertStatusCode = assertStatusCode || defaultSettings_1.defaultAssertStatusCode;
        this.hashFunction = circuitBreakerHash || defaultSettings_1.defaultCircuitBreakerHash;
        this.defaultSettings = defaultSettings;
    }
    Object.defineProperty(HttpApiSettingsBase.prototype, "failureTreshold", {
        get: function () {
            var _a = this, config = _a.config, target = _a.target, defaultSettings = _a.defaultSettings;
            var failureTreshold = defaultSettings.failureTreshold;
            return config.get("http." + target + ".circuitBreaker.failureTreshold") || failureTreshold;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HttpApiSettingsBase.prototype, "minimumSamples", {
        get: function () {
            var _a = this, config = _a.config, target = _a.target, defaultSettings = _a.defaultSettings;
            var minimumSamples = defaultSettings.minimumSamples;
            return config.get("http." + target + ".circuitBreaker.minimumSamples") || minimumSamples;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HttpApiSettingsBase.prototype, "maximumSamples", {
        get: function () {
            var _a = this, config = _a.config, target = _a.target, defaultSettings = _a.defaultSettings;
            var maximumSamples = defaultSettings.maximumSamples;
            return config.get("http." + target + ".circuitBreaker.maximumSamples") || maximumSamples;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HttpApiSettingsBase.prototype, "maxTimeForHalfOpenRequest", {
        get: function () {
            var _a = this, config = _a.config, target = _a.target, defaultSettings = _a.defaultSettings;
            var maxTimeForHalfOpenRequest = defaultSettings.maxTimeForHalfOpenRequest;
            return config.get("http." + target + ".circuitBreaker.maxTimeForHalfOpenRequest") || maxTimeForHalfOpenRequest;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HttpApiSettingsBase.prototype, "openDuration", {
        get: function () {
            var _a = this, config = _a.config, target = _a.target, defaultSettings = _a.defaultSettings;
            var openDuration = defaultSettings.openDuration;
            return config.get("http." + target + ".circuitBreaker.openDuration") || openDuration;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HttpApiSettingsBase.prototype, "samplingDuration", {
        get: function () {
            var _a = this, config = _a.config, target = _a.target, defaultSettings = _a.defaultSettings;
            var samplingDuration = defaultSettings.samplingDuration;
            return config.get("http." + target + ".circuitBreaker.samplingDuration") || samplingDuration;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HttpApiSettingsBase.prototype, "timeout", {
        get: function () {
            var _a = this, config = _a.config, target = _a.target, defaultSettings = _a.defaultSettings;
            var timeout = defaultSettings.timeout;
            return config.get("http." + target + ".timeout") || timeout;
        },
        enumerable: true,
        configurable: true
    });
    return HttpApiSettingsBase;
}());
exports.HttpApiSettingsBase = HttpApiSettingsBase;
//# sourceMappingURL=httpApiSettingsBase.js.map